import countryCodes from "src/constants/countryCodes";

export type Country = {
	key: string;
	text: string;
	value: string;
	icon: string;
	code: string;
};

const getCountryCodes = (): Country[] => {
	return countryCodes
		.map(country => {
			const icon = `/flags/${country.code}.svg`;
			const value = `+${country.phone}`;
			const text = `${country.label} (+${country.phone})`;
			const code = country.code;
			return {
				icon,
				key: country.label,
				text,
				value,
				code,
			};
		})
		.sort((a: Country, b: Country) => (b.key > a.key ? -1 : 1));
};

const getHighlightedCodes = (): Country[] => {
	return countryCodes
		.filter(country => country.highlight)
		.map(country => {
			const icon = `/flags/${country.code}.svg`;
			const value = `+${country.phone}`;
			const text = `${country.label} (+${country.phone})`;
			const code = country.code;
			return {
				icon,
				key: country.label,
				text,
				value,
				code,
			};
		})
		.sort((a: Country, b: Country) => (b.key > a.key ? -1 : 1));
};

const countryToFlag = (isoCode: string) => {
	return typeof String.fromCodePoint !== "undefined"
		? isoCode
				.toUpperCase()
				.replace(/./g, (char: string) => String.fromCodePoint(char.charCodeAt(0) + 127397))
		: isoCode;
};

export { countryToFlag, getCountryCodes, getHighlightedCodes };
